import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaPhone,
  FaLocationArrow,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";
import FooterLogo from "./../../assets/logos/footerLogo.svg";
import googleBadge from "./../../assets/google.png";
import appleBadge from "./../../assets/apple3.png";
import facebook from "../../assets/images/facebook.png";
import twitter from "../../assets/images/x.png";
import youtube from "../../assets/images/youtube.png";
import instagram from "../../assets/images/instagram.png";
import linkedin from "../../assets/images/linkedin.png";
import mail from "../../assets/images/mail.png";
import call from "../../assets/images/call.png";
import telegram from "../../assets/images/telegram.png";

function Footer() {
  return (
    <footer className="footer">
      {/* Upper Section */}
      <div className="footer-upper">
        {/* Left - Logo and Tagline */}
        <div className="footer-upper-left">
          <div 
            className="footer-logo" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img src={FooterLogo} alt="Riso Footer Logo" className="footer-logo-img" />
          </div>
        </div>

        {/* Right - Company and Safety */}
        <div className="footer-upper-right">
          <div className="footer-column">
            <h4 className="footer-heading">Company</h4>
            <ul>
              <li>
                <a href="https://risoapp.com/about-us">About MentorX4u</a>
              </li>
              <li>
                <a href="#servicesec">MentorX4u Services</a>
              </li>
              <li>
                <a href="/contactus">Work at MentorX4u</a>
              </li>
              <li>
                <a href="/blogs">Blogs</a>
              </li>
             
            </ul>
          </div>
          <div className="footer-column">
            <h4 className="footer-heading">Safety</h4>
            <ul>
              <li>
                <a href="/privacy-policy">Fraud Alert</a>
              </li>
              <li>
                <a href="/privacy-policy">Trust & Safety</a>
              </li>
              <li>
                <a href="/privacy-policy">Report Issue</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      <div className="footer-middle">
        {/* Contact Us */}
        <div className="footer-contact-section">
          <h4 className="footer-heading">Contact us</h4>
          <div className="footer-contact">
            <a href="mailto:" className="contact-icon">
            <img src={mail} alt="mail" className="contact-icon" />
            </a>
            <a href="#" className="contact-icon">
             <img src={telegram} alt="mail" className="contact-icon" />
            </a>
            <a href="tel:" className="contact-icon">
             <img src={call} alt="mail" className="contact-icon" />
            </a>
          </div>
          <p className="contact-address">
            7th lane, Sharadhabali, Basudev Nagar, Brahmapur, Odisha 760010
          </p>
        </div>

        {/* Socials */}
        <div className="footer-socials-section">
          <h4 className="footer-heading">Socials</h4>
          <div className="footer-socials">
            
            <a href="https://www.facebook.com/panindiajob.seeker/?viewas=100000686899395" className="social-icon">
              <img src={facebook} alt="Facebook" className="social-icon" />
            </a>
            <a href="https://x.com/app_riso" className="social-icon">
              <img src={twitter} alt="twitter" className="social-icon" />
            </a>
            <a href="https://www.youtube.com/channel/UCBVAGRFnPEt9PQ8DLWycOGg" className="social-icon">
               <img src={youtube} alt="youtube" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/contact.riso/" className="social-icon">
               <img src={instagram} alt="instagram" className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/company/risoapp/" className="social-icon">
                <img src={linkedin} alt="linkedin" className="social-icon" />
            </a>
          </div>
        </div>

        {/* We are also available at */}
        <div className="footer-apps">
          <h4 className="footer-heading">We are also available at</h4>
          <div className="app-badges">
            <a href="https://play.google.com/store/apps/details?id=com.riso">
              <img src={googleBadge} alt="Get it on Google Play" />
            </a>
            <a href="#">
              <img src={appleBadge} alt="Download on App Store" />
            </a>
          </div>
        </div>
      </div>

      {/* Lower Section */}
      <div className="footer-lower">
        <div className="footer-links">
          <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Help</Link>
          <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Terms</Link>
          <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy</Link>
        </div>
        <div className="footer-copy">
           {/* Updated copyright */}
          2026 www.mentorx4u.com All Rights reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
